import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import "ulysses/widgets";

ko.bindingHandlers.sidefavourites = {
    init: function(elt, va, allbindings, model, context) {
        var search_settings = ko.observable({
                "navigable":false,
                "contextual":false,
                "facets_visible": false,
                "show_controls": false,
                "selection_aware": false,
                "actions_visible": false,
                "search_placeholder": _('search_favourites_placeholder', 'Search Favourites'),
                "filter":"is:starred",
                "parameters": { _search_body:null }
        });
        uly.subscribe("entity.starred", function() {
            //hack to get at the model
            var model = $(elt).children(".search").data("search_model");
            if (model) {
                model.query_results();
            }
        }, elt);
        uly.subscribe("entity.unstarred", function() {
            //hack to get at the model
            var model = $(elt).children(".search").data("search_model");
            if (model) {
                model.query_results();
            }
        }, elt);
        var child = context.createChildContext({"settings": search_settings });
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    }
};

$.extend(uly.actions, {
    open_favourites:function(ev,$elt,ui) {
        uly.actions.navigateto("/search?filters=is:starred");
        return false;
    },
    unfollow: function(ev, $elt, ui) {
        var vals = uly.actions.get_$elt_and_ui(ev, ui, "unfollow");
        $elt = vals[0];
        ui = vals[1];
        
        uly.actions.standard_action(ev, $elt, ui).then(function(result) {
            uly.publish("entity.unstarred");
        });
    },
    follow: function(ev, $elt, ui) {
        var vals = uly.actions.get_$elt_and_ui(ev, ui, "follow");
        $elt = vals[0];
        ui = vals[1];
        
        return uly.actions.standard_action(ev, $elt, ui).then(function(result) {
            uly.publish("entity.starred");
        });
    }
});
